<template>

      <div class="card">

        <div class="card-content">
        
          <div class="columns">
        
            <div class="column">
              
              <figure class="image is-3by3 is-inline-block" style="padding:5px; text-align:center;">
                <img
                  class="file-image"
                  v-if="document.mime.includes('image') && !imageError"
                  :src="document.thumbnail"
                  alt
                  @error="imageLoadError"
                >
                <b-icon v-else :icon="getIconByMimeType(document.mime)" size="is-large"></b-icon>
              </figure>

            </div>

            <div class="column">
              <div>
                <p class="title">{{ getFileName(document.filename)}}</p>
                <p class="subtitle is-6">{{ document.createdAt | toLocalDateAndTime }}</p>
              </div>
            </div>
            
            <div class="column">

              <table>
                <tr>
                  <td>{{ document.description }}</td>
                </tr>
                <tr>
                  <td><a href="#" v-for="(tag, index) in document.tags" :key="index">#{{tag.name}} &nbsp;&nbsp;</a></td>
                </tr>
                <tr>
                  <td>{{ document.createdBy ? document.createdBy.fullName : "" }}</td>
                </tr>
              </table>
              

            </div>

            <div class="column" style="display:flex;">

              <a href="#" class="button action-button" @click.prevent="isUpdateFile = true">UPDATE</a>

              <a :href="document.path" class="button action-button" target="_blank">DOWNLOAD</a>
              
            </div>

          </div>
          
        </div>

        <b-modal :active.sync="isUpdateFile" has-modal-card>
          <file-update :file.sync="document" @deleteFile="deleteFile"/>
        </b-modal>

      </div>
    


  <!-- <div class="card equal-height">
    <div class="card-image has-text-centered">
      <figure class="image is-3by3 is-inline-block" style="padding:5px">
        <img
          class="file-image"
          v-if="document.mime.includes('image') && !imageError"
          :src="document.thumbnail"
          alt
          @error="imageLoadError"
        >
        <b-icon v-else :icon="getIconByMimeType(document.mime)" size="is-large"></b-icon>
      </figure>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="title">{{ getFileName(document.filename)}}</p>
        </div>
      </div>

      <div class="content">
        {{ document.description }}
        <br>
        <a href="#" v-for="(tag, index) in document.tags" :key="index">#{{tag.name}} &nbsp;&nbsp;</a>
      </div>
    </div>
    <footer class="card-footer">
      <a href="#" class="card-footer-item" @click.prevent="isUpdateFile = true">UPDATE</a>
      <a :href="document.path" class="card-footer-item" target="_blank">DOWNLOAD</a>
    </footer>

    <b-modal :active.sync="isUpdateFile" has-modal-card>
      <file-update :file.sync="document" @deleteFile="deleteFile"/>
    </b-modal>
  </div> -->
</template>
<script>
import FileUpdate from "@/components/Documents/File/FileUpdate";

export default {
  data: () => ({
    imageError: false,
    isUpdateFile: false
  }),
  components: {
    FileUpdate
  },
  props: {
    document: {
      required: true
    }
  },
  methods: {
    imageLoadError(event) {
      this.imageError = true;
    },
    getFileName(path) {
      var filename = path.replace(/^.*[\\\/]/, "");
      return filename;
    },
    getIconByMimeType(mime) {
      if (mime.includes("image")) {
        return "file-image-o";
      } else if (mime.includes("pdf")) {
        return "file-pdf-o";
      } else if (mime.includes("msword") || mime.includes("word")) {
        return "file-word-o";
      } else if (mime.includes("zip") || mime.includes("rar")) {
        return "file-archive-o";
      } else if (mime.includes("ms-excel") || mime.includes("sheet")) {
        return "file-excel-o";
      } else if (
        mime.includes("ms-powerpoint") ||
        mime.includes("presentation")
      ) {
        return "file-powerpoint-o";
      } else if (mime.includes("text/plain")) {
        return "file-text-o";
      } else {
        return "file";
      }
    },
    deleteFile(file){
      this.$emit('deleteFile', file)
    }
  }
};
</script>
<style lang="scss" scoped>
.equal-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.equal-height .card-footer {
  margin-top: auto;
}
.file-image {
  width: auto;
  max-height: 200px;
}
.card-footer {
  display: flex;
  border-top: 1px solid #dbdbdb;
}
.title {
  font-size: 14px;
}

.card-content{
  margin:20px 0px;
  min-height:100px;
}

.action-button{
  padding:15px !important;
  margin:5px !important;
}

.column{

  display: flex; 
  justify-content: center; 
  align-items: center;

}

</style>



// WEBPACK FOOTER //
// src/components/Documents/Document.vue